module.exports = __webpack_public_path__ + "static/media/MensShirtThree.9c5b31f7.webp";